export default __webpack_public_path__ + "static/media/estimated.f4ff49e1.csv";